import { useEffect, useState } from 'react';
import { AudioUsage, getAudioUsage } from '../api/usageApi';
import { useAuth } from '../auth/AuthContext';

export interface AudioUsageState {
  usage: AudioUsage | null;
  loading: boolean;
  // Re-fetches the allowance. Usage is incremented server-side on generation,
  // so call this after a successful generation to reflect the new count.
  refresh: () => void;
}

// Tracks the signed-in user's weekly audio-generation allowance and keeps it in
// sync after each generation.
export function useAudioUsage(): AudioUsageState {
  const { isAuthenticated } = useAuth();
  const [usage, setUsage] = useState<AudioUsage | null>(null);
  const [loading, setLoading] = useState(true);
  const [nonce, setNonce] = useState(0);

  useEffect(() => {
    let cancelled = false;
    if (!isAuthenticated) {
      setUsage(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    getAudioUsage()
      .then((u) => {
        if (!cancelled) setUsage(u);
      })
      .catch(() => {
        if (!cancelled) setUsage(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [isAuthenticated, nonce]);

  return {
    usage,
    loading,
    refresh: () => setNonce((n) => n + 1),
  };
}
